import { IPersonValues, ITeamValues } from 'types/registration';
import { createStandardAction } from 'typesafe-actions';

const INCREMENT_EVENTS = 'registration/INCREMENT_EVENTS';
const SET_EVENT = 'registration/SET_EVENT';
const SET_TEAM = 'registration/SET_TEAM';
const UPDATE_PERSON = 'registration/UPDATE_PERSON';
const ADD_PERSON = 'registration/ADD_PERSON';
const REMOVE_PERSON = 'registration/REMOVE_PERSON';
const SET_ERRORS = 'registration/SET_ERRORS';
const SUBMIT = 'registration/SUBMIT';
const SET_ERROR = 'registration/SET_ERROR';
const SET_SUBMITTING = 'registration/SET_SUBMITTING';
const RESET_FORM = 'registration/RESET_FORM'

export const incrementEvents = createStandardAction(INCREMENT_EVENTS)();

export interface ISetEventPayload {
  id: string;
  name: string;
}

export const setEvent = createStandardAction(SET_EVENT)<ISetEventPayload>();

export interface ISetTeamPayload {
  name?: string;
  province?: string;
  stadium?: string;
}

export const setTeam = createStandardAction(SET_TEAM)<ISetTeamPayload>();

export interface IUpdatePersonPayload {
  details: {
    name?: string;
    surname?: string;
    contact?: string;
    email?: string;
  };
  // Captain or index of player
  person:
    | 'captain'
    | {
        type: 'player' | 'reserve';
        index: number;
      };
}

export const updatePerson = createStandardAction(UPDATE_PERSON)<
  IUpdatePersonPayload
>();

export interface IAddPersonPayload {
  type: 'player' | 'reserve';
}

export const addPerson = createStandardAction(ADD_PERSON)<IAddPersonPayload>();

export interface IRemovePersonPayload {
  type: 'player' | 'reserve';
  index: number;
}

export const removePerson = createStandardAction(REMOVE_PERSON)<
  IRemovePersonPayload
>();

export interface ISetErrorsPayload {
  event?: string;
  team?: ITeamValues;
  captain?: IPersonValues;
  players?: {
    [key: string]: IPersonValues;
  };
  reserves?: {
    [key: string]: IPersonValues;
  };
  playersError?: string;
  reservesError?: string;
}

export const setErrors = createStandardAction(SET_ERRORS)<ISetErrorsPayload>();

export interface ISubmitFormPayload {
  to: string;
  errorText: string;
  successText: string;
}

export const submitForm = createStandardAction(SUBMIT)<ISubmitFormPayload>();

export interface ISetErrorPayload {
  error: string;
}

export const setError = createStandardAction(SET_ERROR)<ISetErrorPayload>();

export interface ISetSubmittingPayload {
  submitting: boolean;
}

export const setSubmitting = createStandardAction(SET_SUBMITTING)<
  ISetSubmittingPayload
>();

export const resetForm = createStandardAction(RESET_FORM)()


// WEBPACK FOOTER //
// ./src/store/modules/registration/actions.ts